module.exports = "/_next/static/pages/test-guidelines/38137ef86ecf4933034cf9c162f9c71c.png";